var map = {
	"./assessments/en.json": 63538,
	"./assessments/it.json": 71764,
	"./certificate/en.json": 76054,
	"./certificate/it.json": 33472,
	"./community/en.json": 17732,
	"./community/it.json": 82474,
	"./errors/en.json": 98660,
	"./errors/it.json": 60938,
	"./fields/en.json": 2826,
	"./fields/it.json": 88812,
	"./fullScreenEditor/en.json": 12325,
	"./fullScreenEditor/it.json": 43871,
	"./global/en.json": 65052,
	"./global/it.json": 83362,
	"./home/en.json": 28260,
	"./home/it.json": 76650,
	"./invite/en.json": 92182,
	"./invite/it.json": 49600,
	"./journal/en.json": 78886,
	"./journal/it.json": 91280,
	"./moodsAndReactions/en.json": 44166,
	"./moodsAndReactions/it.json": 56560,
	"./multime/en.json": 48934,
	"./multime/it.json": 1520,
	"./notifications/en.json": 35411,
	"./notifications/it.json": 24209,
	"./onboarding/en.json": 5086,
	"./onboarding/it.json": 71944,
	"./privacy/en.json": 15467,
	"./privacy/it.json": 72617,
	"./profile/en.json": 5684,
	"./profile/it.json": 96090,
	"./programs/en.json": 82886,
	"./programs/it.json": 95280,
	"./services/en.json": 86113,
	"./services/it.json": 17667,
	"./stepper/en.json": 67276,
	"./stepper/it.json": 96562,
	"./streams/en.json": 97928,
	"./streams/it.json": 58950,
	"./validation/en.json": 46832,
	"./validation/it.json": 70254,
	"./webinars/en.json": 97068,
	"./webinars/it.json": 26354,
	"./widgets/en.json": 34904,
	"./widgets/it.json": 37046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84649;